import style from "styled-components";
import { Link } from "react-router-dom";

export const CategoriaOuter = style(Link)`
  height:300px;
  background-position: center;
  background-image: ${(props) => `url(${props.img})`};
  color:white;
  text-decoration:none;
  transition:0.4s ease-out;
`;

export const CategoriaInner = style.div`
background-color:transparent;
height:100%;
font-size:${({ theme }) => theme.fontSizes.medium};
line-height: 150px;
cursor:pointer;
text-align: center;
transition:0.4s ease-out;

 &:hover{
      background-color:black;
      opacity:0.5;
      span{
      color:white;
      border:2px solid white;
      padding:1.0rem;
  }
  }
  span{
      color:transparent;
  }
`;
